import { FlowChartContentNodeHeaderBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartContentNodeHeaderBuilder'
import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import {
  AiAgentConfig,
  DEFAULT_ICON_RENDER_SIZE,
} from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { AiAgentNodeType } from 'common/builder/nodes/nodeInterfaces'
import { ChannelIcon, ChannelTypeLabel } from 'common/core/constants/ChannelType'

export const getAiStepHeader = (entity: AiAgentNodeType) => {
  const headerBuilder = new FlowChartContentNodeHeaderBuilder(
    entity.caption,
    new FlowChartIconBuilder(AiAgentConfig.iconComponent, DEFAULT_ICON_RENDER_SIZE).build(),
  )

  if (entity.channel && ChannelIcon[entity.channel]) {
    headerBuilder.withAdditionalIcon(
      new FlowChartIconBuilder(ChannelIcon[entity.channel], DEFAULT_ICON_RENDER_SIZE).build(),
    )
  }

  if (entity.channel && ChannelTypeLabel[entity.channel]) {
    headerBuilder.withSubtitle(ChannelTypeLabel[entity.channel])
  }

  return headerBuilder.build()
}
